<template>
  <router-view v-if="!loadding" />
  <loading v-else />
</template>
<script>
import loading from './components/common/loading.vue'
import { mapGetters } from 'vuex'
import config from './config'
import { logout } from './api/session'
export default {
  components: { loading },
  name: 'Main',
  data () {
    return {
      loadding: true,
      unProtectedRoutes: ['/login', '/signup', '/forgot-password']
    }
  },
  created () {
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    const tenantId = urlParams.get(config.urlKeys.tenantId)
    const targetTenantId = urlParams.get(config.urlKeys.targetTenantId)
    const projectId = urlParams.get(config.urlKeys.projectId)
    const redirectFrom = urlParams.get(config.urlKeys.redirectFrom)
    const useSessionStore = urlParams.get(config.urlKeys.useSessionStorage)
    const path = window.location.pathname
    const pathWithQueryString = window.location.pathname + queryString
    // Preserve auth and tenant state in sessionStorage for new tabs
    if (useSessionStore) {
      sessionStorage.clear()
      const tenantKey = config.localstorageKeys.LAST_OPENED_TENANT
      const authKey = config.localstorageKeys.AUTH
      const collaboratorKey = config.localstorageKeys.COLLABORATOR
      const collaboratorIdKey = config.localstorageKeys.COLLABORATOR_ID

      sessionStorage.setItem(authKey, localStorage.getItem(authKey))
      sessionStorage.setItem(tenantKey, localStorage.getItem(tenantKey))
      localStorage.getItem(collaboratorKey) && sessionStorage.setItem(collaboratorKey, localStorage.getItem(collaboratorKey))
      localStorage.getItem(collaboratorIdKey) && sessionStorage.setItem(collaboratorIdKey, localStorage.getItem(collaboratorIdKey))
      if (projectId && projectId !== 'null') {
        if (JSON.parse(sessionStorage.getItem(collaboratorIdKey))) {
          this.$store.commit('setProjectIdForCollaborator', projectId)
        } else {
          sessionStorage.setItem(config.localstorageKeys.LAST_OPENED_PROJECT, projectId)
        }
      }
    } else if (tenantId) {
      localStorage.setItem(config.localstorageKeys.LAST_OPENED_TENANT, tenantId)
      if (targetTenantId) {
        localStorage.setItem(config.localstorageKeys.TARGET_TENANT_ID, targetTenantId)
      }
      if (localStorage.getItem(config.localstorageKeys.LAST_OPENED_PROJECT) && (!projectId || projectId === 'null' || projectId === 'undefined')) {
        localStorage.removeItem(config.localstorageKeys.LAST_OPENED_PROJECT)
        localStorage.removeItem(config.localstorageKeys.PROJECT)
      }
      if (projectId && projectId !== 'null' && projectId !== 'undefined') {
        if (targetTenantId) {
          this.$store.commit('setProjectIdForCollaborator', projectId)
        } else {
          localStorage.setItem(config.localstorageKeys.LAST_OPENED_PROJECT, projectId)
        }
      }
    }

    if (redirectFrom === 'email') {
      localStorage.setItem(config.localstorageKeys.LAST_PATH, pathWithQueryString)
      localStorage.setItem(config.localstorageKeys.REDIRECT_FROM, redirectFrom)
      if (targetTenantId) {
        localStorage.setItem(config.localstorageKeys.TARGET_TENANT_ID, targetTenantId)
      }
    }
    const authToken = localStorage.getItem(config.localstorageKeys.AUTH)
    if (!(this.unProtectedRoutes.includes(path)) && authToken) {
      this.loadding = true
      this.$store.dispatch('setup', () => {
        if (this.unProtectedRoutes.includes(path)) {
          this.$router.replace('/')
        }
        localStorage.removeItem(config.localstorageKeys.REDIRECT_FROM)
        localStorage.removeItem(config.localstorageKeys.LAST_PATH)
        this.loadding = false
      })
    } else if (!(this.unProtectedRoutes.includes(path)) && !authToken) {
      logout()
    } else {
      this.loadding = false
    }
  },
  computed: {
    ...mapGetters([
      'collaborator'
    ])
  }
}
</script>
<style lang="scss">
body.global-cursor-loading,
body.global-cursor-loading * {
  cursor: wait !important;
}
</style>
